import { render, staticRenderFns } from "./ApproveOption.vue?vue&type=template&id=9ab2acc6&scoped=true"
import script from "./ApproveOption.vue?vue&type=script&lang=js"
export * from "./ApproveOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab2acc6",
  null
  
)

export default component.exports